<template>
  <div class="otp-input">
    <input
        v-for="(digit, index) in otp"
        :key="index"
        v-model="otp[index]"
        @input="handleInput(index, $event)"
        @keydown="handleBackspace(index, $event)"
        @paste.prevent="handlePaste($event)"
        maxlength="1"
        type="text"
        class="otp-input-field"
        :class="{ 'filled': otp[index], 'active': isFocused === index }"
        ref="otpInput"
        @focus="isFocused = index"
        @blur="isFocused = null"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      otp: Array(6).fill(''),
      isFocused: null
    };
  },
  methods: {
    handleInput(index, event) {
      const value = event.target.value;
      if (/^\d$/.test(value)) {
        this.otp[index] = value;
        if (index < this.otp.length - 1) {
          this.$refs.otpInput[index + 1].focus();
        }
      } else {
        this.otp[index] = '';
      }
      this.emitOtp();
    },
    handleBackspace(index, event) {
      if (event.key === 'Backspace' && !this.otp[index] && index > 0) {
        this.$refs.otpInput[index - 1].focus();
      }
      this.emitOtp();
    },
    handlePaste(event) {
      const paste = event.clipboardData.getData('text');
      if (/^\d{6}$/.test(paste)) {
        paste.split('').forEach((digit, index) => {
          if (index < this.otp.length) {
            this.$set(this.otp, index, digit);
          }
        });
        this.emitOtp();
        this.$refs.otpInput[this.otp.length - 1].focus();
      }
    },
    emitOtp() {
      this.$emit('input', this.otp.join(''));
    }
  }
};
</script>

<style scoped>
.otp-input {
  display: flex;
  gap: 8px;
}
.otp-input-field {
  width: 40px;
  padding: 12px 8px;
  font-size: 18px;
  text-align: center;
  border-radius: 4px;
  border: 2px solid var(--login-gray-text-color);
  background-color: var(--gray-color-10-new);
  transition: background-color 0.2s ease, border-color 0.2s ease;
  color: var(--primary-color-new);
}
.otp-input-field.filled {
  background-color: var(--login-auth-bg-color);
  border: 2px solid var(--login-input-bg-color);
}
.otp-input-field.active {
  border-color: var(--text-primary-color-new) !important; /* TODO: failed to change border color on focus */
}
</style>
